
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 40 40","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 0A19.857 19.857 0 007.143 4.743V1.429a1.429 1.429 0 00-2.857 0V8.57A1.429 1.429 0 005.714 10h7.143a1.429 1.429 0 100-2.857H8.73A16.957 16.957 0 0120 2.857 17.143 17.143 0 113.329 16.043a1.429 1.429 0 10-2.772-.657A19.6 19.6 0 000 20 20 20 0 1020 0z"}}),_c('path',{attrs:{"d":"M17.143 27.427a2.858 2.858 0 001.515-.443l7.3-4.557a2.857 2.857 0 000-4.857l-7.3-4.558a2.857 2.857 0 00-4.372 2.415v9.143a2.857 2.857 0 002.857 2.857zm0-12l7.3 4.571-7.3 4.572v-9.143z"}})])
          )
        }
      }
    